/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';
import { ChartType } from '@models/chart.model';

@Component({
  selector: 'app-theme-option-datalabels-text-align',
  templateUrl: './theme-option-datalabels-text-align.component.html',
  styleUrls: ['./theme-option-datalabels-text-align.component.css']
})
export class ThemeOptionDatalabelsTextAlignComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() datalabelsIndex: number;

  color = ItemColor('themes');
  values = ['left', 'center', 'right'];
  optionType: ThemeOptionType = 'datalabels_textAlign';
  showDetails: boolean;

  constructor() {}

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  receiveValue(value: number, type?: ChartType) {
    this.themeOptions.setDatalabels(this.optionType, value, this.datalabelsIndex, type ? [type] : undefined);
  }

}
